/**
 * api接口统一管理
 */
import { get, post, remove, put } from "./http";

// let baseURL = 'https://test.nkdfilm.api.nkodapu.com'
/**
 *
 * @param {string} params
 * 我们定义了一个topics方法
 * 这个方法有一个参数params
 * params是我们请求接口时携带的参数对象
 * 而后调用了我们封装的post方法
 * post方法的第一个参数是我们的接口地址
 * 第二个参数是topics的params参数
 * 即请求接口时携带的参数对象
 * 最后通过export导出topics。
 */
//admin ------api
export const getADMIN = {
  //登录
  login: params =>
    post("/login", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //修改
  set: params => post("/Login/UpdatePassword", params)
};
//退回--------api
export const Refuse = {
  //设置退回原因
  set: params => post("/Bss/AddRefuseInfo", params),
  //获取退回原因
  get: params => post("/Bss/GetRefuseInfo", params)
};
//cplx ------api
export const getCPLX = {
  //获取table列表
  getTable: params => get("/product", params),
  //添加table列表
  addTable: params =>
    post("/product", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/product", params, id),
  //删除table列表
  delTable: params => remove("/product", params)
};
//mjgl ------api
export const getMJGL = {
  //获取table列表
  getTable: params => get("/roll", params),
  //添加table列表
  addTable: params =>
    post("/roll", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/roll", params, id),
  //删除table列表
  delTable: params => remove("/roll", params)
};
//zbcp ------api
export const getZBCP = {
  //根据id获取
  getPositionId: params => get(`/product_type/${params}`),
  //根据id获取
  getTabelId: params => get(`/warranty/${params}`),
  //获取table列表
  getTable: params => get("/warranty", params),
  //添加table列表
  addTable: params =>
    post("/warranty", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/warranty", params, id),
  //删除table列表
  delTable: params => remove("/warranty", params),
  //售后-审核质保
  initiatePass: params =>
    post("/warranty/pass", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //售后-发起质保
  initiateQuality: params =>
    post("/warranty/initiate", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    })
};
//zbkh ------api
export const getZBKH = {
  //获取type列表
  getTypeList: params => post("/Bss/GetProductInfoList", params),
  //获取Province列表
  getProvinceList: params => post("/Bss/QueryPartnerProvince", params),
  //获取Agency列表
  getAgencyList: params => post("/Bss/QueryPartnerByProvince", params),
  //获取经销商门店
  getStoreList: params => post("Bss/QueryStoreByPartnerId", params),
  //获取table列表
  getTable: params => post("/Bss/GetCustomerInfo", params),
  //添加table列表
  addTable: params => post("/Bss/AddWarrantyDetailByAdmin", params),
  //编辑table列表
  editTable: params => post("/Bss/UpdateWarrantyDetail", params),
  //删除table列表
  delTable: params => post("/Bss/DelWarrantyDetail", params),
  //审核
  passTable: params => post("/Bss/PassWarrantyDetail", params),
  //退回
  refuseTable: params => post("/Bss/RefuseWarrantyDetail", params),
  //打印table列表
  downloadTable: params => post("/Bss/GetCustomerExcelInfo", params),
  //获取膜卷号
  getNumberList: params => post("/Bss/GetPNumber", params)
};
//yys ------api
export const getYYS = {
  //获取table列表
  getTable: params => get("/partner", params),
  //添加table列表
  addTable: params =>
    post("/partner", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/partner", params, id),
  //删除table列表
  delTable: params => remove("/partner", params)
};
//md ------api
export const getMD = {
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    }),
  //获取table列表
  getTable: params => get("/store", params),
  //添加table列表
  addTable: params =>
    post("/store", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/store", params, id),
  //删除table列表
  delTable: params => remove("/store", params)
};
//md ------api
export const getSGAL = {
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    }),
  //获取table列表
  getTable: params => get("/case", params),
  //添加table列表
  addTable: params =>
    post("/case", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/case", params, id),
  //删除table列表
  delTable: params => remove("/case", params)
};
//js ------api
export const getJS = {
  //获取table列表
  getTable: params => get("/mechanic", params),
  //添加table列表
  addTable: params =>
    post("/mechanic", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/mechanic", params, id),
  //删除table列表
  delTable: params => remove("/mechanic", params),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};

//xw ------api
export const getXW = {
  //获取table列表
  getTable: params => get("/news", params),
  //添加table列表
  addTable: params =>
    post("/news", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/news", params, id),
  //删除table列表
  delTable: params => remove("/news", params),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};

//img ------api
export const getIMG = {
  //获取type列表
  getTypeList: params => post("/Bss/GetProductInfoList", params),
  //获取table列表
  getTable: params => post("/QCloud/GetImgCaseInfo", params),
  //添加table列表
  addTable: params => post("/QCloud/AddImgCase", params),
  //获取Agency列表
  getAgencyList: params => post("/Bss/QueryPartnerByProvince", params),
  //获取经销商门店
  getStoreList: params => post("Bss/QueryStoreByPartnerId", params),
  //获取brand列表
  getBrandList: params => post("/QCloud/GetImgCaseBrand", params),
  //获取model列表
  getModelList: params => post("/QCloud/GetImgCaseModel", params),
  //编辑table列表
  editTable: params => post("/QCloud/UpdateImgCase", params),
  //删除table列表
  delTable: params => post("/QCloud/DelImgCase", params),
  //审核
  passTable: params => post("/QCloud/PassImgCase", params),
  //退回
  refuseTable: params => post("/QCloud/RefuseImgCase", params),
  getModelLists: params => post("/Car/QueryModelByBrand", params)
};
//video ------api
export const getVIDEO = {
  //获取table列表
  getTable: params => post("/QCloud/GetVideoCaseInfo", params),
  //获取brand列表
  getBrandLists: params => post("/Car/QueryBrand", params),
  //获取model列表
  getModelLists: params => post("/Car/QueryModelByBrand", params),
  //获取brand列表
  getBrandList: params => post("/QCloud/GetVideoCaseBrand", params),
  //获取model列表
  getModelList: params => post("/QCloud/GetVideoCaseModel", params),
  //添加table列表
  addTable: params => post("/QCloud/AddVideoCase", params),
  //编辑table列表
  editTable: params => post("/QCloud/UpdateVideoCase", params),
  //删除table列表
  delTable: params => post("/QCloud/DelVideoCase", params)
};

//cp ------api
export const getCP = {
  //获取部位列表
  getTable: params => get("/product_type", params),
  //添加部位
  addTable: params =>
    post("/product_type", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑产品部位列表
  editTable: (params, id) => put("/product_type", params, id),
  //删除窗膜table列表
  delTable: params => remove("/product_type", params)
};

export const getCPJM = {
  //获取产品系列
  getWFTable: params => get("/product_model", params),
  //添加产品系列
  addWFTable: params =>
    post("/product_model", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑产品系列
  updateWFTable: (params, id) => put("/product_model", params, id),
  //删除table列表
  delWFTable: params => remove("/product_model", params),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};

export const getYP = {
  //获取table列表
  getTable: params => post("/Bss/GetProductPrice", params),
  //添加table列表
  addTable: params => post("/Bss/AddProductPrice", params),
  //编辑table列表
  editTable: params => post("/Bss/UpdateProductPrice", params),
  //编辑table列表
  updateTable: params => post("/Bss/UpdateProductPriceSort", params),
  //删除table列表
  delTable: params => post("/Bss/DelProductPrice", params),
  //获取窗膜列表
  getEPTable: params => post("/Bss/GetEPProductPrice", params),
  //添加窗膜列表
  addEPTable: params => post("/Bss/AddEPProductPrice", params),
  //编辑窗膜table列表
  editEPTable: params => post("/Bss/UpdateEPProductPrice", params),
  //编辑窗膜table列表
  updateEPTable: params => post("/Bss/UpdateEPProductPriceSort", params),
  //删除窗膜table列表
  delEPTable: params => post("/Bss/DelEPProductPrice", params),

  PriceTypeOff: params => post("/Bss/PriceOff", params),
  PriceTypeOn: params => post("/Bss/PriceOn", params),
  priceType: params => post("/Bss/GetAppSetting", params)
};

//qx ------api
export const getQX = {
  //获取table列表
  getTable: params => post("/Login/GetAccountInfo", params),
  //添加table列表
  addTable: params => post("/Login/AddAccount", params),
  //编辑table列表
  editTable: params => post("/Login/UpdateAccount", params),
  //删除table列表
  delTable: params => post("/Login/DelAccount", params)
};
export const getBanner = {
  delBanner: params => remove("/banner", params),
  editBanner: (params, id) => put("/banner", params, id),
  //添加banner
  getBanner: params => get("/banner", params),
  //添加banner
  addBanner: params =>
    post("/banner", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};
export const getQuote = {
  getTable: params => post("/Bss/GetProductPrice", params),
  delTable: params => post("/Bss/DelProductPrice", params),
  updeteTable: params => post("/Bss/UpdateProductPrice", params),
  getproductList: params => post("/Bss/QueryProductListWx", params),
  addTable: params => post("/Bss/AddProductPrice", params),
  GetProductList: params => post("/Bss/GetProductModelByType", params),
  getTypeList: params => post("/Bss/GetProductInfoList", params),
  GetAppSetting: params => post("/Bss/GetAppSetting", params),
  TypeOff: params => post("/Bss/TypeOff", params),
  TypeOn: params => post("/Bss/TypeOn", params)
};
export const carModel = {
  //获取table列表
  getTable: params => get("/car", params),
  //添加table列表
  addTable: params =>
    post("/car", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/car", params, id),
  //删除table列表
  delTable: params => remove("/car", params),
  getTableInfo: params => post("/Car/GetCarInfoById", params)
};
export const carBrand = {
  //获取品牌列表
  getTable: params => get("/car_brand", params),
  //添加table列表
  addTable: params =>
    post("/car_brand", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/car_brand", params, id),
  //删除table列表
  delTable: params => remove("/car_brand", params),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};
export const getXw = {
  //获取table列表
  getTable: params => post("/Bss/GetNewsInfo", params),
  //添加table列表
  addTable: params => post("/Bss/AddNewsInfo", params),
  //编辑table列表
  editTable: params => post("/Bss/UpdateNewsInfo", params),
  //提交table列表
  passTable: params => post("/Bss/PassNewsInfo", params),
  //删除table列表
  delTable: params => post("/Bss/DelNewsInfo", params),
  //获取详情
  getDetails: params => post("/Bss/GetNewsDetail", params),
  //还原新闻位置
  setNewsOrigin: params => post("/Bss/SetNewsOrigin", params),
  //新闻置顶
  setNewsTop: params => post("/Bss/SetNewsTop", params)
};
export const getOur = {
  //获取品牌列表
  getTable: params => get("/about", params),
  //添加table列表
  addTable: params =>
    post("/about", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //编辑table列表
  editTable: (params, id) => put("/about", params, id),
  //删除table列表
  delTable: params => remove("/about", params),
  //添加table列表
  morenTodo: params =>
    post("/about/active", params, {
      headers: { "Content-Type": "application/json;charset=UTF-8" }
    }),
  //上传图片
  upload: params =>
    post("/upload", params, {
      headers: { "Content-Type": "	multipart/form-data" }
    })
};



// WEBPACK FOOTER //
// ./src/axios/api.js